export default {
  sales: [],
  loading: false
}



// WEBPACK FOOTER //
// ./src/modules/report/state.js